import {
  Shield, TrendingDown, UserCheck, Headphones, Globe, Database, Cpu,
  CreditCard, BarChart3, Target, Navigation, ShoppingCart, MessageSquare, Layers,
  CheckCircle2, Activity, Lock, RefreshCw, Users, Eye, LogOut, Anchor, Map,
  type LucideIcon,
} from 'lucide-react';
import type { CxServiceSlug } from '@/i18n/cx.en';

export const BASE_URL = 'https://add-individual-solutions.com';

/** Route slugs for the four CX service lines (order matches t.cx.services.items). */
export const CX_SERVICE_SLUGS: CxServiceSlug[] = [
  'german-customer-support',
  'multilingual-support',
  'back-office-data-processing',
  'cx-consulting-ai',
];

export const isCxServiceSlug = (slug: string | undefined): slug is CxServiceSlug =>
  !!slug && (CX_SERVICE_SLUGS as string[]).includes(slug);

/** Icon keys used in the CX dictionaries → lucide components. */
export const cxIconMap: Record<string, LucideIcon> = {
  shield: Shield,
  trending: TrendingDown,
  usercheck: UserCheck,
  headphones: Headphones,
  globe: Globe,
  database: Database,
  cpu: Cpu,
  creditcard: CreditCard,
  barchart: BarChart3,
  target: Target,
  navigation: Navigation,
  cart: ShoppingCart,
  message: MessageSquare,
  layers: Layers,
  check: CheckCircle2,
  activity: Activity,
  lock: Lock,
  refresh: RefreshCw,
  users: Users,
  eye: Eye,
  logout: LogOut,
  anchor: Anchor,
  map: Map,
};

export const cxIcon = (key: string): LucideIcon => cxIconMap[key] ?? Shield;
